import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { ArrowNext, LoadingSvg } from "../../common/icons";
import { useNavigate } from "react-router";

function NextButton({
  goNextStep,
  isProcessing,
  languages,
  full,
  part,
  isDisabled,
  stepNo,
  currentStep,
  checkBoxTerms,
  confirmOrder,
  reviewLoading,
  checkBoxTermsQBR,
  confirmValidateQBR,
  validateQbr,
  isQbr,
  QBRLoading,
  handleNextStep,
}) {
  const navigate = useNavigate();
  // console.log("isDisabled", isDisabled);
  // console.log("currentStep", currentStep);

  return (
    <>
      <div className="holder-button-sticky w-full py-5 flex justify-center h-88">
        <div className="holder-button w-full flex align-center justify-center">
          {currentStep === 1 && isQbr ? (
            <button
              form="validate-qbr"
              type="button"
              onClick={checkBoxTermsQBR ? confirmValidateQBR : validateQbr}
              className={clsx(
                "btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out",
                {
                  // 'btn-width-full': full ? true : false,
                  "btn-blue": checkBoxTermsQBR ? true : false,
                  "btn-processing": QBRLoading,
                }
              )}
            >
              {QBRLoading ? (
                <span>
                  {" "}
                  {languages.processing ? languages.processing : "Processing"}
                  &nbsp;&nbsp;
                  <LoadingSvg className="process" />
                </span>
              ) : (
                <span>
                  {" "}
                  {languages.validate ? languages.validate : "Validate"}{" "}
                  <ArrowNext className="icon-next" />
                </span>
              )}
            </button>
          ) : currentStep !== 3 ? (
            <button
              type="button"
              // form={
              //     currentStep === 1 ? 'form-product' : ''
              // }
              onClick={(e) => {
                goNextStep(navigate);
              }}
              // disabled={membershipSelected === "" ? true : false}
              className={clsx(
                "btn btn-sticky  btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out",
                {
                  "btn-width-full": full ? true : false,
                  "btn-gray-disabled": isDisabled ? true : false,
                  "btn-processing": isProcessing,
                }
              )}
            >
              {isProcessing ? (
                <span>
                  {languages.processing ? languages.processing : "Processing"}
                  &nbsp;&nbsp; <LoadingSvg className="process" />
                </span>
              ) : (
                <span>
                  {languages.next ? languages.next : "Next"}{" "}
                  <ArrowNext className="icon-next" />
                </span>
              )}
            </button>
          ) : (
            <button
              type="button"
              onClick={(e) => {
                handleNextStep(navigate);
              }}
              // onMouseEnter={!checkBoxTerms ? onMouseHover: ''}
              // onMouseLeave={!checkBoxTerms ? onMouseLeave: ''}
              className={clsx(
                "btn btn-sticky inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out",
                {
                  "btn-blue": checkBoxTerms ? true : false,
                  "btn-gray-disabled-review": !checkBoxTerms,
                  "btn-processing": reviewLoading,
                }
              )}
            >
              {reviewLoading ? (
                <span>
                  {" "}
                  {languages.processing ? languages.processing : "Processing"}
                  &nbsp;&nbsp;
                  <LoadingSvg className="process" />
                </span>
              ) : (
                <span>
                  {languages.confirm ? languages.confirm : "Confirm"}{" "}
                  <ArrowNext className="icon-next" />
                </span>
              )}
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default NextButton;
